module.exports = __webpack_public_path__ + "img/title-2.3cd6d10a.png";